import PocketBase from "pocketbase";

// PocketBase est servi directement par Caddy sur le serveur Hetzner.
// Le Worker historique reste uniquement une relève explicite : le trafic
// normal du portail ne doit plus consommer son quota Cloudflare.
const DEFAULT_POCKETBASE_URL = "https://static.14.84.224.46.clients.your-server.de";

const configuredUrl = String(import.meta.env.VITE_POCKETBASE_URL || DEFAULT_POCKETBASE_URL)
  .trim()
  .replace(/\/+$/, "");

export const pocketbaseUrl = configuredUrl;

// La compilation locale de l'artefact Pages ne reçoit pas toujours les
// variables Cloudflare. Le repli reste donc limité à l'instance NG officielle.
export const pb = new PocketBase(pocketbaseUrl);

pb.autoCancellation(false);

export async function login(identity, password) {
  if (!pocketbaseUrl) throw new Error("VITE_POCKETBASE_URL n’est pas configurée.");
  return pb.collection("core_staff_accounts").authWithPassword(identity, password);
}

export function logout() {
  pb.authStore.clear();
}

export function isAuthenticated() {
  return Boolean(pb.authStore.isValid && pb.authStore.record);
}

export function currentUser() {
  return pb.authStore.record || null;
}

export async function refreshCurrentUser() {
  if (!isAuthenticated()) return null;
  try {
    const result = await pb.collection("core_staff_accounts").authRefresh();
    return result.record;
  } catch {
    logout();
    return null;
  }
}

export function onAuthChange(callback, fireImmediately = true) {
  return pb.authStore.onChange(() => callback(currentUser()), fireImmediately);
}
